import { useState, useCallback } from 'react';
import { UploadFormData, UploadState } from '../services/uploadBusinessLogic';

export const useUploadState = () => {
  const [formData, setFormData] = useState<UploadFormData>({
    title: '',
    description: '',
    category: '',
    tags: '',
    visibility: 'public',
    rating: '',
    language: 'English',
    genres: [],
    subtitles: [],
    trailer: null,
    poster: null,
    posterFile: null,
    posterUrl: '',
    trailerFile: null,
    trailerUrl: '',
    subtitleFiles: [],
    thumbnail: null,
    audioTracks: [],
    ageRestriction: false,
    donationRequired: false,
    commentsEnabled: true,
    linkedContent: '',
    seasonNumber: '',
    episodeNumber: '',
    chapterNumber: '',
    cast: '',
    director: '',
    writer: '',
    contentAdvisory: '',
    languages: [],
    seriesPoster: null,
    seriesTrailer: null,
    episodes: []
  });

  const [uploadState, setUploadState] = useState<UploadState>({
    uploadProgress: 0,
    isUploading: false,
    uploadedFiles: [],
    uploadedFileUrls: [],
    uploadingFiles: new Set(),
    errors: {}
  });

  const updateFormData = useCallback((field: string, value: string | boolean | string[] | File | null | any[]) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  const updateUploadState = useCallback((updates: Partial<UploadState>) => {
    setUploadState(prev => ({
      ...prev,
      ...updates
    }));
  }, []);

  const addError = useCallback((field: string, message: string) => {
    setUploadState(prev => ({
      ...prev,
      errors: {
        ...prev.errors,
        [field]: message
      }
    }));
  }, []);

  const clearErrors = useCallback(() => {
    setUploadState(prev => ({
      ...prev,
      errors: {}
    }));
  }, []);

  const resetForm = useCallback(() => {
    setFormData({
      title: '',
      description: '',
      category: '',
      tags: '',
      visibility: 'public',
      rating: '',
      language: '',
      genres: [],
      subtitles: [],
      trailer: null,
      poster: null,
      posterFile: null,
      posterUrl: '',
      trailerFile: null,
      trailerUrl: '',
      subtitleFiles: [],
      thumbnail: null,
      audioTracks: [],
      ageRestriction: false,
      donationRequired: false,
      commentsEnabled: true,
      linkedContent: '',
      seasonNumber: '',
      episodeNumber: '',
      chapterNumber: '',
      cast: '',
      director: '',
      writer: '',
      contentAdvisory: '',
      languages: [],
      seriesPoster: null,
      seriesTrailer: null,
      episodes: []
    });
    setUploadState({
      uploadProgress: 0,
      isUploading: false,
      uploadedFiles: [],
      uploadedFileUrls: [],
      uploadingFiles: new Set(),
      errors: {}
    });
  }, []);

  return {
    formData,
    uploadState,
    updateFormData,
    updateUploadState,
    addError,
    clearErrors,
    resetForm,
    setFormData
  };
};
